import axios from "axios";
import { multiClientMiddleware } from "redux-axios-middleware";
import axiosMiddlewareOptions from "../../utils/axiosMiddlewareOptions";
import { RootState } from "./../reducers/index";
import thunkMiddleware from "redux-thunk";
import { createStore, applyMiddleware, compose } from "redux";
import { rootReducer } from "../reducers/index";
const config = require("../../../config.js");

const clients = {
  default: {
    client: axios.create({
      baseURL: config.domusoApiService,
      responseType: "json",
    }),
    options: axiosMiddlewareOptions,
  },
};

const middlewares = [thunkMiddleware, multiClientMiddleware(clients)];

let store = {};

export default function configureStore(preloadedState: any) {
  store = createStore(rootReducer, preloadedState, compose(applyMiddleware(...middlewares)));
  return store;
}

export const getCurrentStore = () => {
  return store;
};

export const storeCreator = ({ auth, payment, reservation, logger }: RootState) => {
  return createStore(
    rootReducer,
    { auth, payment, reservation, logger },
    compose(applyMiddleware(...middlewares))
  );
};
